// extracted by mini-css-extract-plugin
module.exports = {"core":"Default-core-2M6_I","sidebar":"Default-sidebar-cEr1I","body":"Default-body-3w3Uy"};